<div
  class="
    d-flex
    flex-column
    justify-content-center
    empty-placeholder
    text-center
  "
>
  <fa-icon [icon]="['fas', 'ghost']" size="5x"></fa-icon>
  <span class="my-3"><ng-content></ng-content></span>
</div>
